import { JSONMapped, jsonProperty } from 'json-mapper-reflect';
import { AvdbDevice } from './avdb-device';

export class AvdbSubscription extends JSONMapped() {
    @jsonProperty()
    id: number;

    @jsonProperty()
    subscriptionUuid: string;

    @jsonProperty()
    billingAccountId: string;

    @jsonProperty()
    sku: string;

    @jsonProperty()
    aircraftUuid: string;

    @jsonProperty()
    endDate: string;

    @jsonProperty()
    renewable: boolean;

    @jsonProperty()
    autorenewalEnabled: boolean;

    @jsonProperty()
    isRedeemed: boolean;

    @jsonProperty()
    redeemable: boolean

    @jsonProperty()
    devices: Array<AvdbDevice>;

    @jsonProperty()
    garminPilotSubscriptions: Array<string>;

    @jsonProperty()
    belongsToBundle: boolean;

	@jsonProperty()
	nextBillDate: string;

    constructor(data?: Partial<AvdbSubscription>) {
        super();
        Object.assign(this, data);
    }
}
